import React from "react";
import reverse from "../../components/reverse.jpeg";

function ReverseLatePayment() {
  return (
    <div className="container">
      <div className="banner">
        <img src={reverse} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>Reverse Late Payments</h1>
          <p>Gain Access to the information on this topic by downloading. </p>
          <p>
            <a href="https://docs.google.com/document/d/1onBNtWCGbxHtBlV-WIUE3gtY4EXxs6R0/edit?usp=drive_link&ouid=117717385823951033045&rtpof=true&sd=true">
              https://docs.google.com/document/d/1onBNtWCGbxHtBlV-WIUE3gtY4EXxs6R0/edit?usp=drive_link&ouid=117717385823951033045&rtpof=true&sd=true
            </a>
          </p>
        </div>
        {/* <div className="downloads"></div> */}
      </div>
    </div>
  );
}

export default ReverseLatePayment;
